<div class="container-fluid">
  <nr-loader />
  <div class="d-flex flex-column">
    <div class="sticky-top bg-white">
      <app-header />
      <nr-banner></nr-banner>
    </div>
    <main
      id="main-content"
      role="main"
      tabindex="-1"
      class="container-router flex-fill ps-0 ps-xl-4-4 d-block"
      style="min-height: calc(100vh - 139px)"
    >
      <div class="dynamic-view row g-0">
        <div class="pb-3 nr-viewport">
          <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
            @if (!isIframe) {
              <router-outlet></router-outlet>
            }
        </div>
      </div>
    </main>
    <app-footer />
  </div>
</div>
